export default "__VITE_ASSET__GKLSDG52__"